import React from "react";

export default function ProofWallCards({ stories }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="proof-wall-cards">
      {stories.map((s) => (
        <figure key={s.id} className="border border-obsidian-600 bg-obsidian-800/40 p-6 flex flex-col hover:border-terracotta/60 transition-colors" data-testid={`proof-wall-card-${s.id}`}>
          <blockquote className="font-serif italic text-lg text-bone-200 leading-relaxed flex-1">
            &ldquo;{s.quote}&rdquo;
          </blockquote>
          <figcaption className="mt-5 flex items-center gap-3">
            <span className="h-9 w-9 rounded-full border border-terracotta/60 flex items-center justify-center font-serif text-bone-100">
              {s.first_name[0]}
            </span>
            <span className="font-sans text-xs uppercase tracking-[0.2em] text-bone-400" data-testid={`proof-wall-card-name-${s.id}`}>
              {s.first_name}
              {s.number ? <span className="whitespace-nowrap"> · Listener №{s.number}</span> : ""}
            </span>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
